import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-components-managecustomer-target-keywords',
  templateUrl: './target-keywords.component.html'
})
export class TargetKeywordsComponent {
  @Input() selectedUrl: Boo.Objects.WebsiteUrl;
}